import styled from '@emotion/styled'
export const StyleLabelWrapper = styled
export const StyleButtonItemsWrapper = styled.div<any>`
  display: flex;
  flex-direction: row;
  column-gap: 15px;
  row-gap: 15px;
  flex: 1;
  width: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  ${(props) => props.styleWrapper}
`

export const StyleButton = styled.button<any>`
  width: fit-content;
  border-radius: 6px;
  border: 1px solid
    ${(props) =>
      props.theme.colors[!!props?.isActive ? 'primary' : 'borderColor']};
  outline: none;
  background: ${(props) =>
    props.theme.colors[props?.isActive ? 'primaryLight' : 'white']};
  height: 40px;
  padding: 0px 20px;
  font-size: 14px;
  color: ${(props) => props.theme.colors[props?.isActive ? 'primary' : 'text']};
  white-space: nowrap;
  ${(props) => props.styleButton}

  display: flex;
  align-items: center;
  gap: 8px;
`
